import type { FieldPath } from 'react-hook-form';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { VySwitchRow } from '@vy/ui-design-system';
import { useChargeContext } from '../../charge-context';
import type { PlanInputForm } from '../../CreatePlanForm/create-plan-form-types/plan-input-form';

export const AutomaticUpgradeSwitch: React.FC = () => {
  const { itemIndex: productIndex } = useChargeContext();
  const { control, getValues, setValue } = useFormContext<PlanInputForm>();

  const { fields: productVariants } = useFieldArray({
    control,
    name: `usageProducts.${productIndex}.variants`,
  });

  const tierLockPath =
    `usageProducts.${productIndex}.variants.0.pricing.priceConfiguration.tierLock` as const;

  const handleTierLockChange = (_event: React.ChangeEvent<HTMLInputElement>, isEnabled: boolean) => {
    productVariants.forEach((_, index) => {
      const variantPath: FieldPath<PlanInputForm> =
        `usageProducts.${productIndex}.variants.${index}.pricing.priceConfiguration.tierLock`;
      setValue(variantPath, isEnabled);
    });
  };

  const currentTierLock = getValues(tierLockPath);

  return (
    <VySwitchRow
      checked={Boolean(currentTierLock)}
      title="Automatic upgrade"
      description="Exceeding the tier usage moves the user to the next tier. Future charges will be billed at the new tier rate"
      onChange={handleTierLockChange}
      data-field-span="full"
      data-vy="usage-charge-drawer-automatic-upgrade-switch"
    />
  );
};
